import React from 'react';
export function Footer() {
  return <footer className="bg-black text-zinc-400 py-12 border-t border-sky-900/40" data-id="element-86">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-87">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-88">
          🇦🇷⭐ MEGAPACK STICKERS MUNDIAL™
        </h4>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-89">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-sky-400 transition-colors" data-id="element-90">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-91">·</span>
          <span className="hover:text-sky-400 transition-colors" data-id="element-92">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-zinc-600 border-t border-zinc-800 pt-8 space-y-3" data-id="element-93">
          <p data-id="element-94">
            © MEGAPACK STICKERS MUNDIAL™ 2026 — Todos los derechos reservados.
          </p>
          <p className="italic text-sky-300/80" data-id="element-95">
            🇦🇷⭐ "La próxima vez que alguien quiera stickers del Mundial — vas a
            ser vos quien se los vende."
          </p>
        </div>
      </div>
    </footer>;
}